import axios from 'api';

// DID inventory — /api/super/dids/

export const getDIDManagementData = (filtersData, signal) => {
  const { page_size, page, search, call_type, country, status, tenant__isnull } = filtersData || {};
  const params = new URLSearchParams();
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  if (search) params.set('search', search);
  if (call_type) params.set('call_type', call_type);
  if (country) params.set('country', country);
  if (status != null) params.set('status', status);
  if (tenant__isnull != null) params.set('tenant__isnull', tenant__isnull);
  return axios.get(`/api/super/dids/?${params.toString()}`, { signal });
};

export const createDIDManagement = (params) => {
  return axios.post(`/api/super/dids/`, params);
};

export const updateDIDManagement = (params) => {
  return axios.patch(`/api/super/dids/${params.id}/`, params);
};

export const deleteDIDManagement = (id) => {
  return axios.delete(`/api/super/dids/${id}/`);
};

export const getAllPublicDIDManagementData = () => {
  return axios.get(`/api/super/dids/?page_size=1000`);
};

// Tenant-scoped DID assignment.
//   getCustomerDIDManagementData lists DIDs already assigned to a tenant.
export const getCustomerDIDManagementData = (filtersData, signal) => {
  const { schema, page_size, page, search } = filtersData;
  return axios.get(
    `/api/super/dids/?tenant__schema_name=${schema}&page_size=${page_size}&page=${page}&search=${search}`,
    { signal }
  );
};

// Body: { id, schema } — assigns the DID to a tenant by schema_name.
export const attachCustomerDIDManagement = ({ id, schema }) => {
  return axios.post(`/api/super/dids/${id}/assign-tenant/`, { schema_name: schema });
};

// Releases a DID from its current tenant (clears the FK).
export const deleteCustomerDIDManagement = ({ id }) => {
  return axios.post(`/api/super/dids/${id}/release-tenant/`);
};

// Bulk DID import.
// Body: { dids: [{caller_id, country, call_type, sip_trunk?}, ...] }
export const bulkImportDIDs = (params) => {
  return axios.post(`/api/super/dids/bulk-import/`, params);
};

// Inbound DIDs (read-only cross-tenant view).
export const getInboundDIDData = (filtersData, signal) => {
  const { page_size, page, search, did_country } = filtersData || {};
  const params = new URLSearchParams();
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  if (search) params.set('search', search);
  if (did_country) params.set('did__country', did_country);
  return axios.get(`/api/super/inbound-dids/?${params.toString()}`, { signal });
};

export const getAllCustomersData = () => {
  return axios.get(`/api/super/tenants/?page_size=1000`);
};

// SIP trunks — /api/super/sip-trunks/. Inbound and outbound now live on the same table;
// the legacy split is preserved here via the transport / direction filter if the backend exposes it.

export const getSipTrunksData = (filtersData, signal) => {
  const { page_size, page, search, tenant, transport } = filtersData || {};
  const params = new URLSearchParams();
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  if (search) params.set('search', search);
  if (tenant != null) params.set('tenant', tenant);
  if (transport) params.set('transport', transport);
  return axios.get(`/api/super/sip-trunks/?${params.toString()}`, { signal });
};

export const createSipTrunk = (params) => {
  return axios.post(`/api/super/sip-trunks/`, params);
};

export const updateSipTrunk = (params) => {
  return axios.patch(`/api/super/sip-trunks/${params.id}/`, params);
};

export const deleteSipTrunk = (id) => {
  return axios.delete(`/api/super/sip-trunks/${id}/`);
};

// Inbound/outbound aliases — keep the legacy call-sites compiling.
export const getInboundTrunksData = (filtersData, signal) =>
  getSipTrunksData({ ...filtersData, transport: 'inbound' }, signal);
export const createInboundTrunk = createSipTrunk;
export const updateInboundTrunk = updateSipTrunk;
export const deleteInboundTrunk = deleteSipTrunk;

export const getOutboundTrunksData = (filtersData, signal) =>
  getSipTrunksData({ ...filtersData, transport: 'outbound' }, signal);
export const createOutboundTrunk = createSipTrunk;
export const updateOutboundTrunk = updateSipTrunk;
export const deleteOutboundTrunk = deleteSipTrunk;

// ─── Legacy stubs ────────────────────────────────────────────────────────
import { removedStub } from 'api/_legacy';
export const createInboundDID = removedStub('createInboundDID');
export const updateInboundDID = removedStub('updateInboundDID');
export const deleteInboundDID = removedStub('deleteInboundDID');
export const getDispatchRulesData = removedStub('getDispatchRulesData');
export const createDispatchRule = removedStub('createDispatchRule');
export const updateDispatchRule = removedStub('updateDispatchRule');
export const deleteDispatchRule = removedStub('deleteDispatchRule');
